import React from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import Home from './pages/Home';
import Header from './components/Header';
import '@fontsource/space-grotesk/400.css';
import '@fontsource/space-grotesk/700.css';
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/700.css';

// Extend the theme to include custom colors, fonts, etc
const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: 'black',
        color: 'white',
        fontFamily: 'DM Sans, system-ui, sans-serif',
      },
    },
  },
  fonts: {
    heading: 'Space Grotesk, sans-serif',
    body: 'DM Sans, sans-serif',
  },
  colors: {
    cyan: {
      400: '#00D2FF',
    },
    purple: {
      400: '#FF00FF',
    },
  },
});

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Header />
      <Home />
    </ChakraProvider>
  );
}

export default App;
